var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCirclefill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.12998 5.47298e-06C7.32184 -0.00197281 5.55373 0.532396 4.04935 1.53551C2.54497 2.53862 1.37192 3.9654 0.678599 5.63534C-0.0147195 7.30528 -0.197149 9.14335 0.15439 10.917C0.505928 12.6906 1.37564 14.3202 2.65349 15.5994C3.93134 16.8787 5.55992 17.7502 7.33318 18.1036C9.10644 18.4571 10.9447 18.2767 12.6154 17.5852C14.2861 16.8937 15.7142 15.7222 16.7189 14.219C17.7237 12.7157 18.26 10.9482 18.26 9.14001C18.26 6.71766 17.2984 4.39438 15.5865 2.68058C13.8746 0.966787 11.5523 0.00265574 9.12998 5.47298e-06ZM7.89998 12.92C7.83226 12.9894 7.7514 13.0445 7.66212 13.0823C7.57284 13.1201 7.47693 13.1397 7.37998 13.14C7.18114 13.1398 6.9905 13.0607 6.84998 12.92L3.58998 9.64001L4.65998 8.64001L7.37998 11.36L13.13 5.64L14.13 6.64L7.89998 12.92Z",
    fill: "#2F3B8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.26,
    height: 18.26,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCirclefill);
export default __webpack_public_path__ + "static/media/CheckCirclefill.18136032.svg";
export { ForwardRef as ReactComponent };